<div class="p-d-flex p-flex-column">
  <kodit-placanja-table [samoNeplaceni]="samoNeplaceni" [isKodit]="true"></kodit-placanja-table>
  <kodit-placanja-table class="p-mt-4" [samoNeplaceni]="samoNeplaceni" [isKodit]="false"></kodit-placanja-table>
</div>
